var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4802 10.2572C15.3796 11.3452 14.9713 12.382 14.303 13.2463C13.6347 14.1107 12.7341 14.7669 11.7065 15.1381C10.6789 15.5092 9.56681 15.5801 8.50041 15.3423C7.43401 15.1045 6.45738 14.5679 5.68481 13.7954C4.91223 13.0228 4.37566 12.0462 4.13788 10.9798C3.9001 9.91336 3.97094 8.8013 4.34212 7.77369C4.7133 6.74608 5.36946 5.84544 6.23382 5.17714C7.09819 4.50885 8.13501 4.10054 9.22296 4C8.586 4.86174 8.27949 5.92347 8.35918 6.99209C8.43887 8.06072 8.89946 9.06525 9.65719 9.82298C10.4149 10.5807 11.4195 11.0413 12.4881 11.121C13.5567 11.2007 14.6184 10.8942 15.4802 10.2572Z",
    stroke: "#545455",
    strokeOpacity: 0.25,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.5ffa66c40813c6323c11e234fd894c6c.svg";
export { ForwardRef as ReactComponent };